import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import {
  addSpeicalday,
  updateSpecialday,
} from "../../Services/Specialday/action";
import moment from "moment";
import { toast } from "react-toastify";

const AddEditSpecialDay = (props) => {
  const location = useLocation();
  const data = location?.state?.data?.allData;
  const navigate = useNavigate();


  const [joiningDate, setJoiningDate] = useState(null);
  const [occasion, setOccasion] = useState("");
  const [isEdit, setIsEdit] = useState(false);


  useEffect(() => {
    if (data && data.id) {
      setIsEdit(true);
      if (data.date) {
        const dateObj = new Date(data.date);
        setJoiningDate(dateObj);
      }
      setOccasion(data.occasion || "");
    }
  }, [data]);

  const handleAdd = async () => {
    try {
      if (!joiningDate || !occasion.trim()) {
        toast.error("Please fill in all required fields.")
        return;
      }
      const formattedDate = moment(joiningDate).format("YYYY-MM-DD");

      const body = {
        date: formattedDate,
        occasion: occasion.trim(),
        special_day: true,
      };

      if (isEdit && data?.id) {
        console.log("Updating special day with ID:", data.id, "Data:", body);
        await props?.updateSpecialday(data.id, body);
      } else {
        console.log("Adding new special day:", body);
        await props?.addSpeicalday(body);
      }

      navigate(-1);
    } catch (error) {
      console.error("Error saving Specialday:", error);
    }
  };

  return (
    <>
      <div className="add-edit-container">
        <div className="page-title">
          <h4>{isEdit ? "Edit Special Day" : "Add Special Day"}</h4>
          <div className="edit-btn">
            <button
              type="button"
              className="custom-btn"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            <button type="button" className="custom-btn" onClick={handleAdd}>
              {isEdit ? "Update" : "Save"}
            </button>
          </div>
        </div>

        <div className="form-part">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="input-group">
              <label htmlFor="joiningDate">Date <span className='required-field'> *</span></label>
              <DatePicker
                id="joiningDate"
                selected={joiningDate}
                onChange={(date) => setJoiningDate(date)}
                dateFormat="dd-MM-yyyy"
                className="form-control"
                placeholderText="Enter Date"
                required
              />
            </div>

            <div className="input-group mt-3">
              <h6 className="label">Occasion <span className='required-field'> *</span></h6>
              <input
                type="text"
                className="input-css"
                name="occasion"
                placeholder="Enter Occasion"
                value={occasion}
                onChange={(e) => setOccasion(e.target.value)}
                required
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    specialday: state.specialdayReducer.holiday,
    loading: state.specialdayReducer.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addSpeicalday: (data) => {
      dispatch(addSpeicalday(data));
    },
    updateSpecialday: (id, data) => {
      dispatch(updateSpecialday(id, data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditSpecialDay);
